import { EventsPage } from './EventsPage';
import { withSectionProtection } from '../../client/components/ProtectedSection';

function FlagshipEventsPage() {
  return <EventsPage variant="flagship" />;
}

export default withSectionProtection(FlagshipEventsPage, 'events');
